
import Main from '../views/main';
import GatheringBalanceList from '../views/gatheringManagement/gatheringBalanceList'
import GatheringBusinessmen from '../views/gatheringManagement/gatheringBusinessmen'
const GatheringRouter = {

    path: '/Gathering',
    component: Main,
    title: '聚商管理',
    icon: 'el-icon-s-custom',
    meta: { keepAlive: true },
    children: [
      {
        path: '/gatheringBusinessmen',
        component:GatheringBusinessmen,
        name: 'gatheringBusinessmen',
        title: '聚商列表',
        meta: { title: '聚商列表'  ,keepAlive:true}
      },
      {
        path: '/gatheringBalanceList',
        component:GatheringBalanceList,
        name: 'gatheringBalanceList',
        title: '聚商上分列表',
        meta: { title: '聚商上分列表'  ,keepAlive:true}
      }
    ]

}
export default GatheringRouter
